/**
 * Frontend-Mirror von src/server/mollie/mollieLocaleMap.ts (Phase 06.1-01).
 * Mappt i18next-Locales auf Mollie-Hosted-Checkout-akzeptierte Werte.
 *
 * Verhalten muss mit Backend identisch sein, sonst sendet Frontend z.B. "de_DE",
 * Backend lehnt es ab und defaulted auf en_US (UX-Penalty).
 */
export function mapLocaleToMollie(locale: string | null | undefined): string | undefined {
    if (locale === null || locale === undefined) {
        return undefined
    }
    const normalized = String(locale).toLowerCase().trim()
    if (normalized === "") {
        return undefined
    }

    if (
        normalized === "de" ||
        normalized === "de-du" ||
        normalized === "de-sie" ||
        normalized === "de-de"
    ) {
        return "de_DE"
    }

    if (normalized === "en" || normalized === "en-us") {
        return "en_US"
    }

    // Unknown locale -> default + warn for later mapping update
    // eslint-disable-next-line no-console
    console.warn("Unmapped locale, defaulting to en_US", { locale })
    return "en_US"
}
